module.exports = "../dist/img/img_1-24.537a.jpg";